import { useState, useEffect } from "react";
import Button from "../common/Button";
import Input from "../common/Input";
import CustomSelect from "../common/CustomSelect";
import { createJob, updateJob } from "../../../services/jobsServices";
import { toast } from "react-hot-toast";
import RichTextEditor from "../common/RichTextEditor";

const statusOptions = [
  { value: "active", label: "Active" },
  { value: "closed", label: "Closed" },
];

const EditJobs = ({ job, jobId }) => {
  const [title, setTitle] = useState("");
  const [experience, setExperience] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [jobDescription, setjobDescription] = useState("");

  useEffect(() => {
    if (job) {
      setTitle(job.title || "");
      setExperience(job.experience || "");
      setLocation(job.location || "");
      setDescription(job.description || "");
      setjobDescription(job.jobDescription || "");
      setStatus(
        job.status
          ? statusOptions.find((option) => option.value === job.status)
          : null
      );
    }
  }, [job]);

  const handleSubmit = async () => {
    if (
      !title ||
      !experience ||
      !location ||
      !description ||
      !status ||
      !jobDescription
    ) {
      toast.error("Please fill in all fields.");
      return;
    }

    const payload = {
      title,
      experience,
      location,
      description,
      jobDescription,
      status: status.value,
    };

    try {
      setLoading(true);
      await updateJob(jobId, payload);
      toast.success("Job updated successfully!");
      setTitle("");
      setExperience("");
      setLocation("");
      setDescription("");
      setStatus(null);
      window.location.href = "/admin/jobs/list";
    } catch (error) {
      toast.error(error.message || "Failed to create job");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#F5F0FF] p-6 rounded-lg font-sans space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Input label="Title" value={title} onChange={setTitle} required />
        <Input
          label="Experience"
          value={experience}
          onChange={setExperience}
          required
        />
        <Input
          label="Location"
          value={location}
          onChange={setLocation}
          required
        />

        <div className="col-span-3">
          <span className="block text-base font-semibold text-black mb-1">
            Job Description
          </span>
          <textarea
            className="w-full border border-gray-300 rounded-md p-3 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#4B00E0] focus:border-transparent transition-all"
            value={jobDescription}
            onChange={(e) => setjobDescription(e.target.value)}
            rows={4}
            maxLength={400}
          />
        </div>
      </div>

      <RichTextEditor
        description={description}
        setDescription={setDescription}
      />

      <div className="grid grid-cols-1 w-1/2 md:grid-cols-2 gap-4">
        <CustomSelect
          label="Status"
          value={status}
          onChange={setStatus}
          options={statusOptions}
          placeholder="Select"
        />
      </div>

      <div className="pt-4 space-y-2">
        <Button className="w-full" onClick={handleSubmit} disabled={loading}>
          {loading ? "Updating..." : "Update Jobs"}
        </Button>
        <Button className="w-full" variant="text">
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default EditJobs;
